import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaskedInput from "./masked-input";
import DateInput from "./date-input";
import TextAreaInput from "./text-area-input";
import { pull } from "lodash";
export default {
  name: "OptionsInput",
  components: {
    MaskedInput,
    DateInput,
    TextAreaInput
  },
  props: {
    prompt: {
      type: String,
      default: ""
    },
    colSize: {
      type: String,
      default: "6"
    },
    value: {
      type: null,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    margin: {
      type: [String, Number],
      default: "0"
    },
    multi: {
      type: Boolean,
      default: false
    },
    articleClass: {
      type: String,
      default: ""
    },
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const defaultInputVal = this.options.some(option => option.multi) ? [] : {
      option: "",
      text: ""
    };
    return {
      answer: this.value || defaultInputVal
    };
  },
  computed: {
    checkedMap() {
      var _this$options$map$red, _context, _context2;
      return (_this$options$map$red = _reduceInstanceProperty(_context = _mapInstanceProperty(_context2 = this.options).call(_context2, opt => opt.value)).call(_context, (acc, curr) => {
        var _context3;
        acc[curr] = _includesInstanceProperty(_context3 = this.answer).call(_context3, curr + "");
        return acc;
      }, {})) != null ? _this$options$map$red : {};
    }
  },
  watch: {
    "answer.option"() {
      this.answer.text = "";
    }
  },
  methods: {
    handleChange() {
      this.$emit("input", this.answer);
    },
    changes(option) {
      if (this.answer.option === option.value) {
        this.answer.option = "";
        this.$emit("input", this.answer);
      }
    },
    handleMultiChange(event) {
      var _context4;
      const {
        value
      } = event.target;
      if (_includesInstanceProperty(_context4 = this.answer).call(_context4, value)) {
        this.answer = pull(this.answer, value);
      } else {
        this.answer.push(value);
      }
      this.$emit("input", this.answer);
    },
    marginByIndex(idx) {
      return idx + 1;
    },
    optionWrapperClass(option) {
      return option.multi ? "pretty p-icon p-jelly p-smooth p-curve col-xs-12" : "fe-option col-xs-12";
    },
    inputComponent(inputType = "text") {
      const inputComponentParser = {
        text: MaskedInput,
        date: DateInput,
        textarea: TextAreaInput
      };
      return inputComponentParser[inputType];
    },
    handleExplainChange(value) {
      if (typeof value == "object") {
        this.answer.text = value.target.value;
      } else {
        this.answer.text = value;
      }
      this.handleChange();
    }
  }
};